import { CanActivateChildFn, CanActivateFn } from "@angular/router";

import type { PermissionActionDescriptorType } from "../../../adaa-types";
import { handleRoutePermission } from "./guards-util";

export function hasPermissionGuard(data: PermissionActionDescriptorType): CanActivateFn | CanActivateChildFn {
  return () => handleRoutePermission(data);
}
